import { render, staticRenderFns } from "./UserPasswordEditor.vue?vue&type=template&id=0ee22474"
import script from "./UserPasswordEditor.vue?vue&type=script&lang=ts"
export * from "./UserPasswordEditor.vue?vue&type=script&lang=ts"
import style0 from "./UserPasswordEditor.vue?vue&type=style&index=0&id=0ee22474&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports